import type { ActiveCashier } from '@core/components/PinPadModal'

/**
 * Кто может открыть локальную админку на кассе.
 *
 * Нельзя опираться на `can_manage_shifts` или `can_correction`: по пресету
 * эти права есть у обычного кассира. Доступ даёт только роль admin либо
 * ЯВНОЕ право `can_open_admin`. Legacy-fallback убран: иначе кассир с
 * `can_correction` мог открыть управление сотрудниками.
 */
export function canOpenAdmin(cashier: ActiveCashier | null | undefined): boolean {
  if (!cashier) return false
  if (cashier.role === 'admin') return true
  return cashier.permissions?.can_open_admin === true
}
